require('./brokerStocksSellView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('commonsComponents/OKButton');
const OKBadge = require('components/commons/OKBadge/OKBadge');

// @ components
const BrokerStocksHeader = require('components/broker/brokerProductHeaders/brokerStocksHeader/brokerStocksHeader');
const {
    BrokerStocksSellStep1
} = require('components/broker/brokerStocksSell/brokerStocksSellStep1/brokerStocksSellStep1');
const BrokerStocksSellStep2 = require('components/broker/brokerStocksSell/brokerStocksSellStep2/brokerStocksSellStep2');
const BrokerStocksSellSuccess = require('components/broker/brokerStocksSell/brokerStocksSellSuccess/brokerStocksSellSuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ actions
const BrokerStocksSellActions = require('actions/brokerStocksSell');
const ProductFileActions = require('actions/brokerGetProductFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const { fetchMyInvestments } = require('actions/brokerMyInvestments');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

//@ContactCenter
const WebappRender = require('components/conditionalRender/webappRender')
// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    COLLECTIVOS_STOCKS_SELL_LOCATION,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    HYPHEN,
    EURO_TEXT,
    BROKER_SELL_SCREEN
} = require('constants/index');
const { OPENTRADER } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('components/broker/brokerStocksSell/analytics/brokerStockSell.tracking');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class BrokerStocksSellView extends React.Component {
    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const { immProfile, history, match: { params: { isin, iso } } } = this.props;
        this.props.getProductCatalogueDetails(isin);
        this.props.fetchMyInvestments();
        this.props.getProductFile(isin, iso, BROKER_SELL_SCREEN);
        this.props.setCodes(this.props.match.params.emisionCode, this.props.match.params.valueCode);
        this.props.fetchOpenTraderLink();
        scrollToTop();

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVOS_STOCKS_SELL_LOCATION, history);
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetProduct();
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/productFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksSell'),
                url: ''
            }
        ];
    }

    getCurrency() {
        const { immMyInvestments } = this.props;

        const stock = immMyInvestments.getIn(['products', 'stocks', 'stocks']).find(stock => {
            return this.props.match.params.isin === stock.get('isin') &&
                this.props.match.params.iso === stock.get('iso');
        }
        );

        return stock ? stock.get('investmentCurrency') : EURO_TEXT;
    }

    getProductDetails = () => {
        const { getProductDetails, match: { params: { isin, iso } } } = this.props;
        getProductDetails(isin, iso, BROKER_SELL_SCREEN);
    }

    buildHeader(productFile, immMyInvestments, immFlagBasedFeatures) {
        return (
            <BrokerStocksHeader
                productFile={productFile}
                immMyInvestments={immMyInvestments}
                handleUpdate={this.getProductDetails}
                noBottomButtons={true}
                immFlagBasedFeatures={immFlagBasedFeatures}
            />
        );
    }

    buildSuccessful() {
        const { immStocksSell, productFile, immSellContracts, match } = this.props;
        const companyName = productFile.get('error') ? HYPHEN : productFile.get('companyName');

        return (
            <div className="broker-stocks-sell-view__success col-lg-12">
                <BrokerStocksSellSuccess
                    productFile={productFile}
                    immStocksSell={immStocksSell}
                    immStocksContracts={immSellContracts}
                    companyName={companyName}
                    isin={match.params.isin}
                />
            </div>
        );
    }

    buildWizard() {
        const {
            immCollectivesCommissions,
            immProfile,
            immSellContracts,
            immStocksSell,
            immFlagBasedFeatures,
            match: { params },
            productFile,
            getExAnteData,
        } = this.props;
        const immSteps = immStocksSell.get('steps');
        const step1 = immSteps.get(0);
        const visibleStep = immStocksSell.get('visibleStep');
        const firstStepLoading = immStocksSell.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immStocksSell.getIn(['steps', SECOND_STEP, 'loading']);
        const productCurrency = productFile.get('error') ? this.getCurrency() : productFile.get('currency');
        const productPrice = productFile.get('error') ? 0 : productFile.get('sellPrice');
        const companyName = productFile.get('error') ? HYPHEN : productFile.get('companyName');
        const contractNumber = params.contractNumber;
        const isCollectiveUser = !!immProfile.get('isCollective');
        const catalogData = productFile.get('catalogData');
        const fees_url = formatText('broker-product_buy_sale_flow_see_fees_link');

        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.finish,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel
        };
        const titleHeaderMenuWizard = visibleStep === 1 ? formatText('broker-stocksSellViewWizardTitle') : formatText('broker-stocksSellViewWizardTitleStepTwo');
        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: []
        };

        if (isCollectiveUser) {
            const commisionsLink = immCollectivesCommissions && immCollectivesCommissions.get('url');
            headerMenuData.extraContent = <OKBadge toUrl={commisionsLink} target={'_blank'} name={formatText('broker-stocksSellViewWizardBadgeLabel').toUpperCase()} />;
        } else {
            headerMenuData.linksData.push({
                label: formatText('broker-commisions'),
                href: fees_url,
                hasTooltip: false,
                target: '_blank'
            });
        }

        if (params.iso === SPANISH_CONTINUES_MARKET_ISO_CODE) {
            headerMenuData.linksData.unshift({
                label: formatText('broker-advancedOrder'),
                href: `/myprofile/broker/stocksAdvancedSell/${params.isin}/${params.iso}/${params.emisionCode}/${params.valueCode}`,
                hasTooltip: false
            });
        }
        const tealiumData = [
            catalogue[analyticsId.BROKER_STOCK_SELL_STEP_1_VIEW]({ productName: params.isin }),
            catalogue[analyticsId.BROKER_STOCK_SELL_STEP_2_VIEW]({ productName: params.isin }),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.BROKER_STOCK_SELL_STEP_1_SUCCESS](),
        ];

        return (
            <div className="broker-stocks-sell-view__content-boxes row">
                <div className="col-lg-12">
                    <Wizard
                        wizardClass={'broker-stocks-sell-view__wizard'}
                        actions={actions}
                        immSteps={immSteps}
                        stepsAmount={immSteps.size}
                        visibleStep={visibleStep}
                        hasHeaderMenu={true}
                        headerMenuData={headerMenuData}
                        tealium={tealiumData[visibleStep - 1]}
                        tealiumEvents={{
                            next: tealiumEvents[visibleStep - 1],
                        }}
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            position="first"
                            cancelButton={true}
                            isLoading={firstStepLoading}
                        >
                            <BrokerStocksSellStep1
                                step1={step1}
                                updateStep1Form={actions.updateStep1Form}
                                productCurrency={productCurrency}
                                productPrice={productPrice}
                                isin={this.props.match.params.isin}
                                iso={this.props.match.params.iso}
                                contractNumber={contractNumber}
                                catalogData={catalogData}
                            />
                        </WizardStep>
                        <WizardStep
                            position="last"
                            immFinalButton="broker-stocksSellFinish"
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            isLoading={secondStepLoading}
                        >
                            <BrokerStocksSellStep2
                                immStocksSell={immStocksSell}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immStocksContracts={immSellContracts}
                                companyName={companyName}
                                productCurrency={productCurrency}
                                productFile={productFile.get('micCode')}
                                immBrokerProductFile={productFile}
                                getExAnteData={getExAnteData}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
            </div>
        );
    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleOnClick = () => {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    }

    render() {
        const { immStocksSell, immMyInvestments, immOpenTrader, productFile, match: { params }, immFlagBasedFeatures } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(productFile, params.isin, params.iso);
        const header = productFile.get('error') ? '' : this.buildHeader(productFile, immMyInvestments, immFlagBasedFeatures)
        let contractBoxContent;

        if (productFile.get('isFetched')) {
            if (immStocksSell.get('submitSuccessful')) {
                contractBoxContent = this.buildSuccessful();
            } else if (params.isin) {
                contractBoxContent = this.buildWizard();
            }
        }

        return (
            <div className="broker-stocks-sell-view">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="broker-stocksSellViewTitle"
                        breadcrumbConfig={mappingBreadcrumb}
                        className="broker-stocks-sell-view__header"
                    >
                        <OKButton inverse={true} modifier="ghost" onClick={() => this.handleOnClick()}>
                            <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                        </OKButton>
                        <FeatureTogglingRender notAllowedProductKey={OPENTRADER}>
                            <WebappRender>
                                <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                    <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                </OKButton>
                            </WebappRender>
                        </FeatureTogglingRender>
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
                <section className="broker-stocks-sell-view__body">
                    {header}
                    <div className="broker-stocks-sell-view__wizard-container" id="printable-wizard">
                        {contractBoxContent}
                    </div>
                </section>
            </div>
        );
    }
}

BrokerStocksSellView.propTypes = {
    productFile: PropTypes.object,
    history: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immOpenTrader: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immStocksSell: PropTypes.object,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    finish: PropTypes.func,
    validateStep: PropTypes.func,
    getProductFile: PropTypes.func,
    resetProduct: PropTypes.func.isRequired,
    match: PropTypes.object,
    immSellContracts: PropTypes.object,
    reset: PropTypes.func,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    getExAnteData: PropTypes.func.isRequired,
    setCodes: PropTypes.func.isRequired,
    getCollectivesCommissionsInfo: PropTypes.func,
    immCollectivesCommissions: PropTypes.object,
    getProductDetails: PropTypes.func,
    getProductCatalogueDetails: PropTypes.func,
};

module.exports.constructor = BrokerStocksSellView;
module.exports.BrokerStocksSellView = connect(
    state => ({
        immCollectivesCommissions: state.collectivesCommissions,
        immProfile: state.profile,
        immStocksSell: state.brokerStocksSell,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        productFile: state.brokerProductFile,
        immSellContracts: state.brokerStocksContract,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        reset: BrokerStocksSellActions.reset,
        setVisibleStep: BrokerStocksSellActions.setVisibleStep,
        setWillLeave: BrokerStocksSellActions.setWillLeave,
        setWillCancel: BrokerStocksSellActions.setWillCancel,
        validateStep: BrokerStocksSellActions.validateStep,
        finish: BrokerStocksSellActions.finish,
        getProductFile: ProductFileActions.getProductFileWithCatalogData,
        resetProduct: ProductFileActions.reset,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        setCodes: BrokerStocksSellActions.setCodes,
        getExAnteData: BrokerStocksSellActions.getExAnteData,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo,
        fetchMyInvestments,
        getProductDetails: ProductFileActions.getProductFile,
        getProductCatalogueDetails: ProductFileActions.getStocksCatalogueDetails,
    }
)(withRouter(BrokerStocksSellView));
